/** 57 individually illustrated symbols with transparent print and web assets. */
export const CLASSIC_SYMBOLS = [
  {
    "id": 0,
    "slug": "soleil",
    "name": "Soleil",
    "pt": "Sol",
    "image": "/symbols/classic/v2/soleil.png",
    "thumbnail": "/symbols/classic/v2/web/soleil.webp",
    "portable": "/symbols/classic/v2/portable/soleil.webp"
  },
  {
    "id": 1,
    "slug": "lune",
    "name": "Lune",
    "pt": "Lua",
    "image": "/symbols/classic/v2/lune.png",
    "thumbnail": "/symbols/classic/v2/web/lune.webp",
    "portable": "/symbols/classic/v2/portable/lune.webp"
  },
  {
    "id": 2,
    "slug": "etoile",
    "name": "Étoile",
    "pt": "Estrela",
    "image": "/symbols/classic/v2/etoile.png",
    "thumbnail": "/symbols/classic/v2/web/etoile.webp",
    "portable": "/symbols/classic/v2/portable/etoile.webp"
  },
  {
    "id": 3,
    "slug": "nuage",
    "name": "Nuage",
    "pt": "Nuvem",
    "image": "/symbols/classic/v2/nuage.png",
    "thumbnail": "/symbols/classic/v2/web/nuage.webp",
    "portable": "/symbols/classic/v2/portable/nuage.webp"
  },
  {
    "id": 4,
    "slug": "eclair",
    "name": "Éclair",
    "pt": "Raio",
    "image": "/symbols/classic/v2/eclair.png",
    "thumbnail": "/symbols/classic/v2/web/eclair.webp",
    "portable": "/symbols/classic/v2/portable/eclair.webp"
  },
  {
    "id": 5,
    "slug": "arc-en-ciel",
    "name": "Arc-en-ciel",
    "pt": "Arco-íris",
    "image": "/symbols/classic/v2/arc-en-ciel.png",
    "thumbnail": "/symbols/classic/v2/web/arc-en-ciel.webp",
    "portable": "/symbols/classic/v2/portable/arc-en-ciel.webp"
  },
  {
    "id": 6,
    "slug": "flocon",
    "name": "Flocon",
    "pt": "Floco de neve",
    "image": "/symbols/classic/v2/flocon.png",
    "thumbnail": "/symbols/classic/v2/web/flocon.webp",
    "portable": "/symbols/classic/v2/portable/flocon.webp"
  },
  {
    "id": 7,
    "slug": "pomme",
    "name": "Pomme",
    "pt": "Maçã",
    "image": "/symbols/classic/v2/pomme.png",
    "thumbnail": "/symbols/classic/v2/web/pomme.webp",
    "portable": "/symbols/classic/v2/portable/pomme.webp"
  },
  {
    "id": 8,
    "slug": "banane",
    "name": "Banane",
    "pt": "Banana",
    "image": "/symbols/classic/v2/banane.png",
    "thumbnail": "/symbols/classic/v2/web/banane.webp",
    "portable": "/symbols/classic/v2/portable/banane.webp"
  },
  {
    "id": 9,
    "slug": "fraise",
    "name": "Fraise",
    "pt": "Morango",
    "image": "/symbols/classic/v2/fraise.png",
    "thumbnail": "/symbols/classic/v2/web/fraise.webp",
    "portable": "/symbols/classic/v2/portable/fraise.webp"
  },
  {
    "id": 10,
    "slug": "cerises",
    "name": "Cerises",
    "pt": "Cerejas",
    "image": "/symbols/classic/v2/cerises.png",
    "thumbnail": "/symbols/classic/v2/web/cerises.webp",
    "portable": "/symbols/classic/v2/portable/cerises.webp"
  },
  {
    "id": 11,
    "slug": "ananas",
    "name": "Ananas",
    "pt": "Abacaxi",
    "image": "/symbols/classic/v2/ananas.png",
    "thumbnail": "/symbols/classic/v2/web/ananas.webp",
    "portable": "/symbols/classic/v2/portable/ananas.webp"
  },
  {
    "id": 12,
    "slug": "pasteque",
    "name": "Pastèque",
    "pt": "Melancia",
    "image": "/symbols/classic/v2/pasteque.png",
    "thumbnail": "/symbols/classic/v2/web/pasteque.webp",
    "portable": "/symbols/classic/v2/portable/pasteque.webp"
  },
  {
    "id": 13,
    "slug": "carotte",
    "name": "Carotte",
    "pt": "Cenoura",
    "image": "/symbols/classic/v2/carotte.png",
    "thumbnail": "/symbols/classic/v2/web/carotte.webp",
    "portable": "/symbols/classic/v2/portable/carotte.webp"
  },
  {
    "id": 14,
    "slug": "champignon",
    "name": "Champignon",
    "pt": "Cogumelo",
    "image": "/symbols/classic/v2/champignon.png",
    "thumbnail": "/symbols/classic/v2/web/champignon.webp",
    "portable": "/symbols/classic/v2/portable/champignon.webp"
  },
  {
    "id": 15,
    "slug": "fleur",
    "name": "Fleur",
    "pt": "Flor",
    "image": "/symbols/classic/v2/fleur.png",
    "thumbnail": "/symbols/classic/v2/web/fleur.webp",
    "portable": "/symbols/classic/v2/portable/fleur.webp"
  },
  {
    "id": 16,
    "slug": "cactus",
    "name": "Cactus",
    "pt": "Cacto",
    "image": "/symbols/classic/v2/cactus.png",
    "thumbnail": "/symbols/classic/v2/web/cactus.webp",
    "portable": "/symbols/classic/v2/portable/cactus.webp"
  },
  {
    "id": 17,
    "slug": "arbre",
    "name": "Arbre",
    "pt": "Árvore",
    "image": "/symbols/classic/v2/arbre.png",
    "thumbnail": "/symbols/classic/v2/web/arbre.webp",
    "portable": "/symbols/classic/v2/portable/arbre.webp"
  },
  {
    "id": 18,
    "slug": "feuille",
    "name": "Feuille",
    "pt": "Folha",
    "image": "/symbols/classic/v2/feuille.png",
    "thumbnail": "/symbols/classic/v2/web/feuille.webp",
    "portable": "/symbols/classic/v2/portable/feuille.webp"
  },
  {
    "id": 19,
    "slug": "chat",
    "name": "Chat",
    "pt": "Gato",
    "image": "/symbols/classic/v2/chat.png",
    "thumbnail": "/symbols/classic/v2/web/chat.webp",
    "portable": "/symbols/classic/v2/portable/chat.webp"
  },
  {
    "id": 20,
    "slug": "chien",
    "name": "Chien",
    "pt": "Cachorro",
    "image": "/symbols/classic/v2/chien.png",
    "thumbnail": "/symbols/classic/v2/web/chien.webp",
    "portable": "/symbols/classic/v2/portable/chien.webp"
  },
  {
    "id": 21,
    "slug": "lapin",
    "name": "Lapin",
    "pt": "Coelho",
    "image": "/symbols/classic/v2/lapin.png",
    "thumbnail": "/symbols/classic/v2/web/lapin.webp",
    "portable": "/symbols/classic/v2/portable/lapin.webp"
  },
  {
    "id": 22,
    "slug": "ours",
    "name": "Ours",
    "pt": "Urso",
    "image": "/symbols/classic/v2/ours.png",
    "thumbnail": "/symbols/classic/v2/web/ours.webp",
    "portable": "/symbols/classic/v2/portable/ours.webp"
  },
  {
    "id": 23,
    "slug": "hibou",
    "name": "Hibou",
    "pt": "Coruja",
    "image": "/symbols/classic/v2/hibou.png",
    "thumbnail": "/symbols/classic/v2/web/hibou.webp",
    "portable": "/symbols/classic/v2/portable/hibou.webp"
  },
  {
    "id": 24,
    "slug": "grenouille",
    "name": "Grenouille",
    "pt": "Sapo",
    "image": "/symbols/classic/v2/grenouille.png",
    "thumbnail": "/symbols/classic/v2/web/grenouille.webp",
    "portable": "/symbols/classic/v2/portable/grenouille.webp"
  },
  {
    "id": 25,
    "slug": "poisson",
    "name": "Poisson",
    "pt": "Peixe",
    "image": "/symbols/classic/v2/poisson.png",
    "thumbnail": "/symbols/classic/v2/web/poisson.webp",
    "portable": "/symbols/classic/v2/portable/poisson.webp"
  },
  {
    "id": 26,
    "slug": "papillon",
    "name": "Papillon",
    "pt": "Borboleta",
    "image": "/symbols/classic/v2/papillon.png",
    "thumbnail": "/symbols/classic/v2/web/papillon.webp",
    "portable": "/symbols/classic/v2/portable/papillon.webp"
  },
  {
    "id": 27,
    "slug": "abeille",
    "name": "Abeille",
    "pt": "Abelha",
    "image": "/symbols/classic/v2/abeille.png",
    "thumbnail": "/symbols/classic/v2/web/abeille.webp",
    "portable": "/symbols/classic/v2/portable/abeille.webp"
  },
  {
    "id": 28,
    "slug": "escargot",
    "name": "Escargot",
    "pt": "Caracol",
    "image": "/symbols/classic/v2/escargot.png",
    "thumbnail": "/symbols/classic/v2/web/escargot.webp",
    "portable": "/symbols/classic/v2/portable/escargot.webp"
  },
  {
    "id": 29,
    "slug": "coccinelle",
    "name": "Coccinelle",
    "pt": "Joaninha",
    "image": "/symbols/classic/v2/coccinelle.png",
    "thumbnail": "/symbols/classic/v2/web/coccinelle.webp",
    "portable": "/symbols/classic/v2/portable/coccinelle.webp"
  },
  {
    "id": 30,
    "slug": "tortue",
    "name": "Tortue",
    "pt": "Tartaruga",
    "image": "/symbols/classic/v2/tortue.png",
    "thumbnail": "/symbols/classic/v2/web/tortue.webp",
    "portable": "/symbols/classic/v2/portable/tortue.webp"
  },
  {
    "id": 31,
    "slug": "fusee",
    "name": "Fusée",
    "pt": "Foguete",
    "image": "/symbols/classic/v2/fusee.png",
    "thumbnail": "/symbols/classic/v2/web/fusee.webp",
    "portable": "/symbols/classic/v2/portable/fusee.webp"
  },
  {
    "id": 32,
    "slug": "soucoupe",
    "name": "Soucoupe volante",
    "pt": "Disco voador",
    "image": "/symbols/classic/v2/soucoupe.png",
    "thumbnail": "/symbols/classic/v2/web/soucoupe.webp",
    "portable": "/symbols/classic/v2/portable/soucoupe.webp"
  },
  {
    "id": 33,
    "slug": "planete",
    "name": "Planète",
    "pt": "Planeta",
    "image": "/symbols/classic/v2/planete.png",
    "thumbnail": "/symbols/classic/v2/web/planete.webp",
    "portable": "/symbols/classic/v2/portable/planete.webp"
  },
  {
    "id": 34,
    "slug": "couronne",
    "name": "Couronne",
    "pt": "Coroa",
    "image": "/symbols/classic/v2/couronne.png",
    "thumbnail": "/symbols/classic/v2/web/couronne.webp",
    "portable": "/symbols/classic/v2/portable/couronne.webp"
  },
  {
    "id": 35,
    "slug": "coeur",
    "name": "Cœur",
    "pt": "Coração",
    "image": "/symbols/classic/v2/coeur.png",
    "thumbnail": "/symbols/classic/v2/web/coeur.webp",
    "portable": "/symbols/classic/v2/portable/coeur.webp"
  },
  {
    "id": 36,
    "slug": "diamant",
    "name": "Diamant",
    "pt": "Diamante",
    "image": "/symbols/classic/v2/diamant.png",
    "thumbnail": "/symbols/classic/v2/web/diamant.webp",
    "portable": "/symbols/classic/v2/portable/diamant.webp"
  },
  {
    "id": 37,
    "slug": "cle",
    "name": "Clé",
    "pt": "Chave",
    "image": "/symbols/classic/v2/cle.png",
    "thumbnail": "/symbols/classic/v2/web/cle.webp",
    "portable": "/symbols/classic/v2/portable/cle.webp"
  },
  {
    "id": 38,
    "slug": "cadenas",
    "name": "Cadenas",
    "pt": "Cadeado",
    "image": "/symbols/classic/v2/cadenas.png",
    "thumbnail": "/symbols/classic/v2/web/cadenas.webp",
    "portable": "/symbols/classic/v2/portable/cadenas.webp"
  },
  {
    "id": 39,
    "slug": "ampoule",
    "name": "Ampoule",
    "pt": "Lâmpada",
    "image": "/symbols/classic/v2/ampoule.png",
    "thumbnail": "/symbols/classic/v2/web/ampoule.webp",
    "portable": "/symbols/classic/v2/portable/ampoule.webp"
  },
  {
    "id": 40,
    "slug": "reveil",
    "name": "Réveil",
    "pt": "Despertador",
    "image": "/symbols/classic/v2/reveil.png",
    "thumbnail": "/symbols/classic/v2/web/reveil.webp",
    "portable": "/symbols/classic/v2/portable/reveil.webp"
  },
  {
    "id": 41,
    "slug": "ciseaux",
    "name": "Ciseaux",
    "pt": "Tesoura",
    "image": "/symbols/classic/v2/ciseaux.png",
    "thumbnail": "/symbols/classic/v2/web/ciseaux.webp",
    "portable": "/symbols/classic/v2/portable/ciseaux.webp"
  },
  {
    "id": 42,
    "slug": "crayon",
    "name": "Crayon",
    "pt": "Lápis",
    "image": "/symbols/classic/v2/crayon.png",
    "thumbnail": "/symbols/classic/v2/web/crayon.webp",
    "portable": "/symbols/classic/v2/portable/crayon.webp"
  },
  {
    "id": 43,
    "slug": "livre",
    "name": "Livre",
    "pt": "Livro",
    "image": "/symbols/classic/v2/livre.png",
    "thumbnail": "/symbols/classic/v2/web/livre.webp",
    "portable": "/symbols/classic/v2/portable/livre.webp"
  },
  {
    "id": 44,
    "slug": "enveloppe",
    "name": "Enveloppe",
    "pt": "Envelope",
    "image": "/symbols/classic/v2/enveloppe.png",
    "thumbnail": "/symbols/classic/v2/web/enveloppe.webp",
    "portable": "/symbols/classic/v2/portable/enveloppe.webp"
  },
  {
    "id": 45,
    "slug": "musique",
    "name": "Note de musique",
    "pt": "Nota musical",
    "image": "/symbols/classic/v2/musique.png",
    "thumbnail": "/symbols/classic/v2/web/musique.webp",
    "portable": "/symbols/classic/v2/portable/musique.webp"
  },
  {
    "id": 46,
    "slug": "guitare",
    "name": "Guitare",
    "pt": "Violão",
    "image": "/symbols/classic/v2/guitare.png",
    "thumbnail": "/symbols/classic/v2/web/guitare.webp",
    "portable": "/symbols/classic/v2/portable/guitare.webp"
  },
  {
    "id": 47,
    "slug": "tambour",
    "name": "Tambour",
    "pt": "Tambor",
    "image": "/symbols/classic/v2/tambour.png",
    "thumbnail": "/symbols/classic/v2/web/tambour.webp",
    "portable": "/symbols/classic/v2/portable/tambour.webp"
  },
  {
    "id": 48,
    "slug": "cerf-volant",
    "name": "Cerf-volant",
    "pt": "Pipa",
    "image": "/symbols/classic/v2/cerf-volant.png",
    "thumbnail": "/symbols/classic/v2/web/cerf-volant.webp",
    "portable": "/symbols/classic/v2/portable/cerf-volant.webp"
  },
  {
    "id": 49,
    "slug": "ballon",
    "name": "Ballon de baudruche",
    "pt": "Balão",
    "image": "/symbols/classic/v2/ballon.png",
    "thumbnail": "/symbols/classic/v2/web/ballon.webp",
    "portable": "/symbols/classic/v2/portable/ballon.webp"
  },
  {
    "id": 50,
    "slug": "cadeau",
    "name": "Cadeau",
    "pt": "Presente",
    "image": "/symbols/classic/v2/cadeau.png",
    "thumbnail": "/symbols/classic/v2/web/cadeau.webp",
    "portable": "/symbols/classic/v2/portable/cadeau.webp"
  },
  {
    "id": 51,
    "slug": "parapluie",
    "name": "Parapluie",
    "pt": "Guarda-chuva",
    "image": "/symbols/classic/v2/parapluie.png",
    "thumbnail": "/symbols/classic/v2/web/parapluie.webp",
    "portable": "/symbols/classic/v2/portable/parapluie.webp"
  },
  {
    "id": 52,
    "slug": "bateau",
    "name": "Bateau",
    "pt": "Barco",
    "image": "/symbols/classic/v2/bateau.png",
    "thumbnail": "/symbols/classic/v2/web/bateau.webp",
    "portable": "/symbols/classic/v2/portable/bateau.webp"
  },
  {
    "id": 53,
    "slug": "voiture",
    "name": "Voiture",
    "pt": "Carro",
    "image": "/symbols/classic/v2/voiture.png",
    "thumbnail": "/symbols/classic/v2/web/voiture.webp",
    "portable": "/symbols/classic/v2/portable/voiture.webp"
  },
  {
    "id": 54,
    "slug": "velo",
    "name": "Vélo",
    "pt": "Bicicleta",
    "image": "/symbols/classic/v2/velo.png",
    "thumbnail": "/symbols/classic/v2/web/velo.webp",
    "portable": "/symbols/classic/v2/portable/velo.webp"
  },
  {
    "id": 55,
    "slug": "avion",
    "name": "Avion",
    "pt": "Avião",
    "image": "/symbols/classic/v2/avion.png",
    "thumbnail": "/symbols/classic/v2/web/avion.webp",
    "portable": "/symbols/classic/v2/portable/avion.webp"
  },
  {
    "id": 56,
    "slug": "glace",
    "name": "Glace",
    "pt": "Sorvete",
    "image": "/symbols/classic/v2/glace.png",
    "thumbnail": "/symbols/classic/v2/web/glace.webp",
    "portable": "/symbols/classic/v2/portable/glace.webp"
  }
] as const;
